import { FC } from 'react';
import { SvgIcon } from '@/components';

import styles from './DetailsLinkButton.module.sass';

interface DetailsLinkButtonProps {
  onClick: () => void;
}

const DetailsLinkButton: FC<DetailsLinkButtonProps> = ({ onClick }) => (
  <button type="button" className={styles.detailsLink} onClick={onClick}>
    <SvgIcon name="arrow-right" />
  </button>
);

export default DetailsLinkButton;
